import { StyleSheet } from 'react-native';

const styles = StyleSheet.create({
    container: {
    },
    content: {
        paddingHorizontal: 25,
    }
});

export default styles;
